import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from 'i18next';
import { CopyLink } from './CopyLink';

import './InviteColleague.scss';

export const InviteColleague = () => {
  const { t: translate } = useTranslation<Namespace<'account'>>('account');

  return (
    <section className="invite-colleague sass-migrated">
      <h2 className="title-l">{translate('invite_colleague.title')}</h2>
      <p>{translate('invite_colleague.instruction')}</p>
      <CopyLink />
    </section>
  );
};
